import React from 'react';
import { HubspotFormStoryblok } from '../../../_shared/interfaces/storyblok';
import { getRichTextMarkup, StoryblokCommon } from '../../../lib/storyblok/storyblok';
import { trackEvent } from '../../../lib/track/track';

declare global {
    interface Window {
        hbspt: any;
    }
}

const HubspotForm = ({ blok, storyblokCommon }: { blok: HubspotFormStoryblok; storyblokCommon: StoryblokCommon }) => {
    const [lastHubspotParams, setLastHubspotParams] = React.useState({ region: '', portalId: '', formId: '' });

    if (storyblokCommon.configuration.content.theme === 'dr') {
        import('./hubspot-form.dr.scss').then();
    } else {
        import('./hubspot-form.hs.scss').then();
    }

    const createForm = (region: string, portalId: string, formId: string): void => {
        if (
            typeof window !== 'undefined' &&
            window.hbspt &&
            (lastHubspotParams.region !== region || lastHubspotParams.portalId !== portalId || lastHubspotParams.formId !== formId)
        ) {
            setLastHubspotParams({ region, portalId, formId });

            window.hbspt.forms.create({
                region,
                portalId,
                formId,
                target: '#hubspot-form',
            });
        }
    };

    const trackInteraction = React.useCallback(() => {
        document.removeEventListener('keydown', trackInteraction, false);
        switch (blok.tracking_type) {
            case 'contact':
                trackEvent('form.open', { form: { type: 'contact' } });
                break;
            case 'feedback':
                trackEvent('feedback.open', {});
                break;
        }
    }, []);

    const trackHSFormSend = React.useCallback(() => {
        window.removeEventListener('hsvalidatedsubmit', trackHSFormSend, false);
        switch (blok.tracking_type) {
            case 'contact':
                trackEvent('form.sent', { form: { type: 'contact' } });
                break;
            case 'feedback':
                trackEvent('feedback.sent', {});
                break;
        }
    }, []);

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://js.hsforms.net/forms/v2.js';
            script.id = 'hubspot-script';
            const existingScript = document.getElementById('hubspot-script');

            if (!existingScript) {
                document.body.appendChild(script);
            }

            script.addEventListener('load', () => {
                createForm(blok.region, blok.portalId, blok.formId);
            });
        }
    }, []);

    React.useEffect(() => {
        createForm(blok.region, blok.portalId, blok.formId);
        if (typeof window !== 'undefined') {
            window.addEventListener('hsvalidatedsubmit', trackHSFormSend, false);
            document.addEventListener('keydown', trackInteraction, false);
            return () => {
                window.removeEventListener('hsvalidatedsubmit', trackHSFormSend, false);
                document.removeEventListener('keydown', trackInteraction, false);
            };
        }
    }, [blok]);

    return (
        <div>
            <div>
                <h4>{blok.headline}</h4>
                <div dangerouslySetInnerHTML={getRichTextMarkup(blok.copytext)} />
            </div>
            <div id="hubspot-form" className={'theme-' + storyblokCommon.configuration.content.theme} />
        </div>
    );
};

export default HubspotForm;
